import {useActiveRoute} from '../../../hooks/use-active-route'
import {useFeatureState} from '../../../hooks/use-feature-state'
import {FeatureState} from '../../../page-data/payloads/header'
import {OverviewFeedback} from './OverviewFeedback'
import {Button} from '@primer/react'
import {useToggleFeaturePreview} from '../../../hooks/use-toggle-feature-preview'
import {useLayoutRouteData} from '../../../page-data/loaders/use-layout-route-data'
import {usePullRequestAnalytics} from '../../../hooks/use-pull-request-analytics'
import {isFeatureEnabled} from '@github-ui/feature-flags'

export function OverviewFeatureToggle() {
  const {urls} = useLayoutRouteData()
  const toggleFeature = useToggleFeaturePreview('prs_overview_react')
  const renderState = useOverviewToggleRenderState()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()

  // we can't use useOverviewIsIndexRoute here because true means it is the index route (via feature preview on + FF)
  // but we want to know if enabling the feature will redirect to the index route (via FF only)
  const enablementWillRedirectToIndex = isFeatureEnabled('prs_overview_as_index_route')

  const handleToggleOn = async () => {
    sendPullRequestAnalyticsEvent('overview.feature_toggle', 'OVERVIEW_FEATURE_TOGGLE', {enabled: true})
    await toggleFeature()

    if (enablementWillRedirectToIndex) {
      window.location.href = `${urls.conversation}?overview=true`
    } else {
      window.location.href = `${urls.overview}?overview=true`
    }
  }

  if (renderState === 'feedback') {
    return <OverviewFeedback />
  }

  if (renderState === 'toggle') {
    return (
      <Button onClick={handleToggleOn} variant="invisible" size="small" aria-label="Try the Overview page">
        <span aria-hidden="true">✨ </span>
        Try the Overview page
      </Button>
    )
  }

  return null
}

// This hook is a bit redundant with the logic in PullRequestHeader, but it allows us to keep the rendering logic
// for the overview feature preview in one place and avoid potential bugs where the header and the toggle get out of sync.
export function useOverviewToggleRenderState() {
  const overviewFeatureState = useFeatureState('overview')
  const activeRoute = useActiveRoute()

  if (overviewFeatureState === FeatureState.Enabled && activeRoute === 'overview') {
    return 'feedback'
  }

  if (overviewFeatureState === FeatureState.Available && activeRoute === 'conversation') {
    return 'toggle'
  }

  return 'none'
}
